/**
 * Utility to detect device information from user agent
 */

export function getDeviceInfo() {
  const userAgent = navigator.userAgent;

  // Detect browser
  let browser = "Unknown";
  if (userAgent.includes("Firefox")) {
    browser = "Firefox";
  } else if (userAgent.includes("Chrome") && !userAgent.includes("Edge")) {
    browser = "Chrome";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    browser = "Safari";
  } else if (userAgent.includes("Edge")) {
    browser = "Edge";
  } else if (userAgent.includes("Opera")) {
    browser = "Opera";
  }

  // Detect OS
  let os = "Unknown";
  if (userAgent.includes("Windows")) {
    os = "Windows";
  } else if (userAgent.includes("Mac OS")) {
    os = "macOS";
  } else if (userAgent.includes("Linux")) {
    os = "Linux";
  } else if (userAgent.includes("Android")) {
    os = "Android";
  } else if (userAgent.includes("iOS")) {
    os = "iOS";
  }

  // Detect platform
  let platform = "Desktop";
  if (/Mobi|Android/i.test(userAgent)) {
    platform = "Mobile";
  } else if (/Tablet|iPad/i.test(userAgent)) {
    platform = "Tablet";
  }

  return {
    platform,
    browser,
    os,
    userAgent,
    registeredAt: new Date(),
    lastUsed: new Date(),
  };
}
